const user ={
    state:{
        token:"",
        isLogin:false,
        loginVisible:false,  //控制登录框显示
        routerTo:"",     //目标路由地址
        ifOut:false
    },
    mutations:{
        set_ifOut(state,value){
            state.ifOut = value;
        },
        set_unread(state,value){
            state.unread = value;
        },
        add_token(state,token){
            state.token=token;
            localStorage.setItem("token",token);
        },
        del_token(state){
            state.token="";
            localStorage.removeItem("token");
        },
        set_isLogin(state){
            state.isLogin=true;
        },
        del_isLogin(state){
            state.isLogin=false;
        },
        set_routerTo(state,value){
            state.routerTo=value;
        },
        set_loginVisible(state){
            //state.loginVisible=!state.loginVisible;
            state.loginVisible=true;
        },
        del_loginVisible(state){
            //state.loginVisible=!state.loginVisible;
            state.loginVisible=false;
        },
    },
    actions:{
        setIfOut({commit},value){
            commit("set_ifOut",value);
        },
        setUnread({commit},value){
            commit('set_unread',value);
        },
        addToken({commit},token){
            commit('add_token',token);
        },
        removeToken({commit}){
            commit('del_token');
        },
        setIsLogin({commit}){
            commit("set_isLogin");
            sessionStorage.setItem("isLogin",true);
        },
        delIsLogin({commit}){
            commit("del_isLogin");
            sessionStorage.removeItem("isLogin");
        },
        //del_loginVisible
        setLoginVisible({commit}){
            commit("set_loginVisible");
        },
        delLoginVisible({commit}){
            commit("del_loginVisible");
        },
        setRouterTo({commit},value){
            commit("set_routerTo",value);
        },
    }
}
export default user
